module.exports = __webpack_public_path__ + "static/img/Stade-de-France.6c61551.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Stade-de-France.jpg
// module id = nOcp
// module chunks = 0